import firebase from 'firebase'

// Laundryvue - LIVE PROJECT!!
//REMEMBER TO CHANGE window.location.replace("http://localhost:8080/") in registreRoom.vue OG registre.vue
// const config = {
//     apiKey: "AIzaSyDUCXQO4YZTsGDxxw80cngI1L3_d0AEVOU",
//     authDomain: "laundryvue.firebaseapp.com",
//     databaseURL: "https://laundryvue.firebaseio.com",
//     projectId: "laundryvue",
//     storageBucket: "laundryvue.appspot.com",
//     messagingSenderId: "608951337036"
// }


// LaundryAtlantis - DEVELOPMENT PROJECT
const config = {
   apiKey: "AIzaSyAHgpYxfnh5bUzl03zgjQS05MQOz-7_39g",
   authDomain: "laundryatlantis.firebaseapp.com",
   databaseURL: "https://laundryatlantis.firebaseio.com",
   projectId: "laundryatlantis",
   storageBucket: "laundryatlantis.appspot.com",
   messagingSenderId: "837969374450"
 };

export const app = firebase.initializeApp(config)
export const db = app.database()



// WEBPACK FOOTER //
// ./src/firebase.js